<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="user-box d-flex" *ngIf="user">
  <div class="img-wrapper">
    <img src="{{ user.avatar }}" alt="{{ user.names }}" *ngIf="user.avatar" class="avatar-img" />
    <span *ngIf="!user.avatar" class="no-avatar"><i class="fas fa-user"></i></span>
  </div>
  <div class="names d-flex align-items-center">
    <span>
      {{ user.names }}
    </span>
  </div>
</div>
